import React from 'react';
import { LazyImage } from '@landing/ui';

import * as styles from './Certificates.module.scss';

export default function Certificates({ certificates }) {
  return (
    <div className={styles.wrapper}>
      {certificates.map(({ src, alt }) => (
        <LazyImage key={src} className={styles.certificate} src={src} alt={alt} />
      ))}
    </div>
  );
}
